import { msg } from '@gonfalon/messages/msg';
import { Icon } from '@launchpad-ui/icons';

import { CopyButton } from '../../internal/components/AgentInsights/components/CopyButton';

import { SpanDetailsIconButton } from './internal/SpanDetailsIconButton';
import { ErrorChip } from './ToolCallRow';

import { investigationLabelLoading } from '../../internal/components/conversation/ConversationChrome.css';
import { actions, chevron, icon as iconClass, label as labelClass, row, toggle } from './CommandGroupRow.css';

export const CommandGroupRow: React.FC<{
  label: string;
  icon?: React.ReactNode;
  expanded: boolean;
  onToggle: () => void;
  errorCount?: number;
  isLoading?: boolean;

  copyText?: string;
  onCopy?: () => void;
  onShowDetails?: () => void;
}> = ({ label, icon, expanded, onToggle, errorCount = 0, isLoading = false, copyText, onCopy, onShowDetails }) => (
  <div className={row} data-follows-message={copyText ? true : undefined}>
    <button type="button" className={toggle} aria-expanded={expanded} onClick={onToggle}>
      {icon ? (
        <span className={iconClass} aria-hidden>
          {icon}
        </span>
      ) : null}
      <span
        className={[labelClass, isLoading ? investigationLabelLoading : undefined].filter(Boolean).join(' ')}
        title={label}
      >
        {label}
      </span>
      <span className={chevron} data-open={expanded} aria-hidden>
        <Icon name="chevron-right" size="small" />
      </span>
      <ErrorChip count={errorCount} />
    </button>
    {copyText || onShowDetails ? (
      <div className={actions} data-follows-message={copyText ? true : undefined}>
        {copyText ? (
          <CopyButton
            redesign
            text={copyText}
            label={msg('vega.conversation.copyReplyLabel')}
            successTitle={msg('vega.conversation.copyReplySuccess')}
            onCopy={onCopy}
          />
        ) : null}
        {onShowDetails ? <SpanDetailsIconButton onPress={onShowDetails} /> : null}
      </div>
    ) : null}
  </div>
);
